import { Platform } from "./models";

// Exceptions
export class Exception {
    constructor(public message: string) { 
    }
}

export class ParametersParseFailException extends Exception {
    constructor(public parameter: string) {
        super("Failed parsing parameters: " + parameter);
    }
}

export class UnsupportedPlatformException extends Exception {
    constructor(public platform: Platform) {
        super("Platform " + platform.toString() + " not supported.");
    }
}

export class UploadFailedExpection extends Exception {
    constructor() {
        super("Upload failed.");
    }
}

export class NonSquarePixelException extends Exception {
    constructor() {
        super("The image is not supported (non-square pixels)");
    }
}